export type Theme = "light" | "dark";

const KEY = "glosor_theme";

export function getStoredTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    return v === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function applyTheme(t: Theme): void {
  document.documentElement.classList.toggle("dark", t === "dark");
}

export function setTheme(t: Theme): void {
  try {
    localStorage.setItem(KEY, t);
  } catch {
    // localStorage unavailable; keep the in-memory toggle only.
  }
  applyTheme(t);
}
